import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Alert } from 'src/app/models/alert';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private http = inject(HttpClient);

  private subject = new Subject<void>();
  alertUrl = environment.ildatoArticoliDpi + 'api/alert';

  list(): Observable<Alert[]> {
    return this.http.get<Alert[]>(this.alertUrl);
  }

  sendClickEvent() {
    this.subject.next();
  }

  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }
}
